import React, { useState, useEffect } from 'react';
import { History } from '../../../../../../_metronic/helpers/components/History';
import { Toggle } from '../../../../../../_metronic/partials/layout/explore/Toggle';
import { CuentasCobrarForm } from './CuentasCobrarForm';
import {
  useGetHistoryCuentasCobrar,
  useInsertMessageCuentasCobrar,
} from '../../hooks/CuentasCobrarHook';
type Props = {
  cuentaCobrarId: number;
};

const ViewCuentasCobrarForm: React.FC<Props> = ({ cuentaCobrarId }) => {
  const [reloadGrid, setReloadGrid] = useState<number>(Math.random() * 40);
  const [showTimerHistory, setShowTimerHistory] = useState<boolean>(true);
  const [showHistory, setShowHistory] = useState<boolean>(true);
  const [search, setSearch] = useState<string>('');
  const { data } = useGetHistoryCuentasCobrar(
    reloadGrid,
    search,
    cuentaCobrarId.toString()
  );
  const { insertData, loadingInsert } = useInsertMessageCuentasCobrar();

  const onRefreshData = () => {
    setReloadGrid(Math.random() * 40);
  };

  const historyStyle: React.CSSProperties = {
    transform: showHistory ? 'none' : 'translateX(110%)',
    transition: 'transform 0.4s ease-in-out',
  };

  const saveMessage = (message: string) => {
    insertData(message, cuentaCobrarId);
  };

  useEffect(() => {
    if (loadingInsert) {
      setReloadGrid(Math.random() * 40);
    }
  }, [loadingInsert]);

  useEffect(() => {
    if (!showHistory) {
      setTimeout(() => {
        setShowTimerHistory(false);
      }, 400);
    }
  }, [showHistory]);

  useEffect(() => {
    const historyMode = localStorage.getItem('isOpenHistory') || '';
    setShowHistory(historyMode ? JSON.parse(historyMode) : true);
    setShowTimerHistory(historyMode ? JSON.parse(historyMode) : true);
  }, []);

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="flex-lg-row-fluid transform">
          <CuentasCobrarForm
            cuentaCobrarId={cuentaCobrarId}
            onRefreshHistory={onRefreshData}
            // onDisabledHistory={onDisabledHistory}
          />
        </div>
        <div style={historyStyle}>
          {Number(cuentaCobrarId) > 0 && showTimerHistory && (
            <>
              <div className="flex-column flex-lg-row-auto w-100 w-xl-400px ms-lg-10">
                <History
                  data={data}
                  onSaveMessage={saveMessage}
                  disabled={false}
                  onShow={() => {
                    setShowHistory(!showHistory);
                    const boolean = !showHistory;
                    localStorage.setItem('isOpenHistory', boolean.toString());
                  }}
                />
              </div>
            </>
          )}
        </div>
        {!showHistory && Number(cuentaCobrarId) > 0 && (
          <Toggle
            onShow={() => {
              setShowHistory(!showHistory);
              setShowTimerHistory(true);
              const boolean = !showHistory;
              localStorage.setItem('isOpenHistory', boolean.toString());
            }}
          />
        )}
      </div>
    </>
  );
};

export { ViewCuentasCobrarForm };
